import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http';
import { Observable, of } from 'rxjs/index';
import { catchError, tap } from 'rxjs/internal/operators';
import { EnvironmentService } from '../environment.service';

@Injectable({
    providedIn: 'root'
})

export class ApplicationService {

    // store the URL so we can redirect after logging in
    redirectUrl: string;
	err: any;
    apiUrl;
	username;
	password;
    httpOptions;

    constructor(private http: HttpClient, private envService: EnvironmentService) {
        this.apiUrl = this.envService.read('apiUrl');
		this.username = this.envService.getCredential('username');
        this.password = this.envService.getCredential('password');
        this.setHttpHeaders();
    }

    setHttpHeaders() {
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
				'Authorization': `Basic ${btoa(this.username + ':' + this.password)}`
            })
        };
    }

    downloadCountReport(args): Observable<any> {
        this.httpOptions.params = new HttpParams().set('fromDate', args.fromDate).set('toDate', args.toDate);
        let appId = args.appId;
        return this.http.get<any>(`${this.apiUrl}/cron/admin/generate/count/document/appId/`+appId,
            this.httpOptions).pipe(
                tap(),
                catchError((error) => {

                    return of(error);
                })
            );
    }

	getApplicationList(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/list`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('getApplicationList', this.err))
            );
    }

	getApplicationDetails(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/details`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('getApplicationDetails', this.err))
            );
    }

    getDashboardChartDetails(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/dashboard/monthly/active/users/details`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('getDashboardChartDetails', this.err))
            );
    }
    getMonthlyActiveUsers(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/monthly/active/users/count`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('getMonthlyActiveUsers', this.err))
            );
    }

	getConnectorDetails(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/connectors/details`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('getConnectorDetails', this.err))
            );
    }

	updateBotDetails(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/update/bot/details`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('updateBotDetails', this.err))
            );
    }

	deleteBotDetails(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/delete/bot/details`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('updateBotDetails', this.err))
            );
    }

	addBotDetails(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/add/bot/details`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('addBotDetails', this.err))
            );
    }

	addApplication(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/create`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('addApplication', this.err))
            );
    }

    updateCustomerId(args): Observable<any> {

        return this.http.post<any>(`${this.apiUrl}/application/update/customer/id`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('updateCustomerId', this.err))
            );
    }

    updateCustomerName(args): Observable<any> {

        return this.http.post<any>(`${this.apiUrl}/application/update/customer/name`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('updateCustomerName', this.err))
            );
    }

	addConnector(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/add/connector`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('addConnector', this.err))
            );
    }

	deleteConnector(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/remove/connector`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('deleteConnector', this.err))
            );
    }

	validateBotDetails(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/validate/bot/details`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('validateBotDetails', this.err))
            );
    }

	addWebhookDetails(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/add/webhook/details`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('addWebhookDetails', this.err))
            );
    }

	deleteApplication(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/delete`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('deleteApplication', this.err))
            );
    }

    updateApplicationName(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/update/name`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('updateApplicationName', this.err))
            );
    }

    updateApplicationURLHandle(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/add/urlhandle`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('updateApplicationURLHandle', this.err))
            );
    }

	getUserCount(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/users/count`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('getUserCount', this.err))
            );
    }

	getMessageSentCount(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/messages/sent/count`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('getMessageSentCount', this.err))
            );
    }

	getMessageReceivedCount(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/total/messages/received`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('getMessageReceivedCount', this.err))
            );
    }

	getConnectorMessageSentCount(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/connector/messages/sent/count`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('getConnectorMessageSentCount', this.err))
            );
    }

	getConnectorHsmSentCount(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/hsm/messages/count`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('getConnectorHsmSentCount', this.err))
            );
    }

	setTranslationLanguage(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/add/translation/language`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('setTranslationLanguage', this.err))
            );
    }

	enableTranslation(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/enable/response/language/translation`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('enableTranslation', this.err))
            );
    }

    updateTranslationCount(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/enable/response/language/translation`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('enableTranslation', this.err))
            );
    }

    callBackPersistCount(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/callback/count`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('enableTranslation', this.err))
            );
    }

    callbackpersist(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/enable/callbackpersist`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('enableTranslation', this.err))
            );
    }

    deleteRetryMessages(args): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/delete/retrymessages`,args,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('Deleteretrymessages', this.err))
            );
    }

    totalSentMsgCount(arg): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/sent/count`,arg,

            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('enableTranslation', this.err))
            );
    }

    totalTemplatecount(arg): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/template/details`,arg,

            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('enableTranslation', this.err))
            );
    }
    totalReceivedMsgCount(arg): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/received/count`,arg,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('enableTranslation', this.err))
            );
    }

	getLanguageList(): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/translation/language`,{},
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('getLanguageList', this.err))
            );
    }

    getCreatedUsersCount(arg): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/total/users`, arg,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('getCreatedUsersCount', this.err))
            );
    }

    getApiToken(arg): Observable<any> {
        return this.http
          .post<any>(
            `${this.apiUrl}/application/generate/api/token`,
            arg,
            this.httpOptions
          )
          .pipe(tap(), catchError(this.handleError("getApiToken", this.err)));
    }

    getNumberOfMessagesSentCount(arg): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/connector/sent/count`, arg,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('getNumberOfMessagesSentCount', this.err))
            );
    }

    renewedReceivedMsgCount(arg): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/received/count`, arg,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('renewedReceivedMsgCount', this.err))
            );
    }

    renewedSentMsgCount(arg): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/sent/count`, arg,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('renewedsentMsgCount', this.err))
            );
    }


    getNumberOfConnectionsCount(arg): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/connector/connection/count`, arg,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('getNumberOfConnectionsCount', this.err))
            );
    }

    getHsmMessagesCount(arg): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/hsm/count`, arg,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('getHsmMessagesCount', this.err))
            );
    }

    updateApplicationDescription(arg): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/update/description`, arg,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('updateApplicationDescription', this.err))
            );
    }

    receivedNotificationMessage(arg): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/status/received/count`,arg,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('enableTranslation', this.err))
            );
    }
    audiototextCount(arg){
        return this.http.post<any>(`${this.apiUrl}/application/audiototext/count`,arg,
        this.httpOptions).pipe(
            tap(),
            catchError(this.handleError('enableTranslation', this.err))
        );
    }

    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error('error on operation', operation, error); // log to console instead

            // TODO: better job of transforming error for user consumption
            // this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }
    QRcodeUpload(arg): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/application/add/channelQrCode`,arg,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('enableTranslation', this.err))
            );
    }
    twitterFetchAuth(applicationId): Observable<any> {
        let arg = {
            applicationId: applicationId
        }
        let apiUrl = this.apiUrl.replace(/(^\w+:|^)\/\//, '');
        console.log("apiUrl", apiUrl)
        return this.http.post<any>(`https://uebackendadminuser:Black!ceT1gerWave@${apiUrl}/application/twitter/fetch/oauth/token`,arg,
            this.httpOptions).pipe(
                tap(),
                catchError(this.handleError('enableTranslation', this.err))
            );
    }
}
